import React from 'react';
import { useTranslation } from 'react-i18next';
import { CAT_CONFIG, SETTING_LABEL, SETTING_ICON, priceLabel, distLabel } from '../lib/data';

export default function ActivityCard({ activity, onDetails, userLat, userLng, index = 0, rating = null, googleRating = null, googleRatingTotal = null }) {
  const { t } = useTranslation();
  const cat  = CAT_CONFIG[activity.category] || CAT_CONFIG.entertainment;
  const dist = distLabel(activity, userLat, userLng);

  return (
    <div
      onClick={() => onDetails(activity)}
      style={{
        background: '#fff',
        borderRadius: 16,
        boxShadow: '0 2px 10px rgba(0,0,0,.06)',
        border: '1px solid #f0f0f0',
        overflow: 'hidden',
        cursor: 'pointer',
        flexShrink: 0,
        animation: `cardIn .3s ease ${index * 55}ms both`,
      }}
    >
      {/* Photo placeholder */}
      <div style={{
        height: 120,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: 44,
        background: cat.bg,
        position: 'relative',
        flexShrink: 0,
      }}>
        {cat.emoji}
        <span style={{
          position: 'absolute', top: 9, left: 9,
          background: cat.color, color: '#fff',
          fontSize: 11, fontWeight: 700,
          padding: '3px 8px', borderRadius: 99,
        }}>
          {cat.label}
        </span>
        <span style={{
          position: 'absolute', top: 9, right: 9,
          background: 'rgba(255,255,255,.85)',
          fontSize: 11, padding: '3px 7px',
          borderRadius: 99, color: '#555', fontWeight: 600,
        }}>
          {SETTING_ICON[activity.setting]} {SETTING_LABEL[activity.setting]}
        </span>
      </div>

      {/* Content */}
      <div style={{ padding: '11px 13px 13px' }}>
        <div style={{ fontWeight: 800, fontSize: 14, color: '#111', marginBottom: 3 }}>
          {activity.name}
        </div>
        <div style={{
          color: '#888', fontSize: 12, lineHeight: 1.45, marginBottom: 9,
          display: '-webkit-box', WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical', overflow: 'hidden',
        }}>
          {activity.description}
        </div>

        {/* Meta row */}
        <div style={{ display: 'flex', alignItems: 'center', gap: 7, fontSize: 12, marginBottom: 10, flexWrap: 'wrap' }}>
          <span style={{ color: '#555' }}>👶 {activity.ageMin}–{activity.ageMax} lat</span>
          <span style={{ width: 3, height: 3, borderRadius: 99, background: '#ddd', display: 'inline-block', flexShrink: 0 }} />
          <span style={{ fontWeight: 700, color: activity.priceType === 'free' ? '#4CAF50' : '#333' }}>
            {priceLabel(activity)}
          </span>
          <span style={{ width: 3, height: 3, borderRadius: 99, background: '#ddd', display: 'inline-block', flexShrink: 0 }} />
          <span style={{ color: '#aaa' }}>📍 {dist}</span>
          
          {googleRating && (
            <>
              <span style={{ width: 3, height: 3, borderRadius: 99, background: '#ddd', display: 'inline-block', flexShrink: 0 }} />
              <span style={{ color: '#555', fontWeight: 600 }}>
                {'🌐 ' + googleRating}
              </span>
            </>
          )}
          {rating && (
            <>
              <span style={{ width: 3, height: 3, borderRadius: 99, background: '#ddd', display: 'inline-block', flexShrink: 0 }} />
              <span style={{ color: '#FFB300', fontWeight: 700 }}>
                {'⭐ ' + rating.avg + ' (' + rating.count + ')'}
              </span>
            </>
          )}
        </div>

        {/* Address + CTA */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 7 }}>
          <div style={{ fontSize: 11, color: '#bbb', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
            {activity.address}
          </div>
          <button
            onClick={e => { e.stopPropagation(); onDetails(activity); }}
            style={{
              background: cat.color, color: '#fff', border: 'none',
              borderRadius: 9, padding: '6px 13px',
              fontWeight: 700, fontSize: 12,
              whiteSpace: 'nowrap', flexShrink: 0,
              cursor: 'pointer', fontFamily: 'inherit',
            }}
          >
            {t('list.details')}
          </button>
        </div>
      </div>
    </div>
  );
}